export type DepthTierLabel =
  | 'PlatinumEdge'
  | 'Platinum'
  | 'Gold'
  | 'Silver'
  | 'Branded'
  | 'Basic';

const getDepthTierLabel = (
  profileTier?: string | null,
  depthTier?: string | null,
): DepthTierLabel | undefined => {
  if (depthTier?.replace(/[^a-z]/gi, '').toLowerCase() === 'platinumedge') {
    return 'PlatinumEdge';
  }

  switch (profileTier) {
    case 'platinum':
      return 'Platinum';
    case 'gold':
      return 'Gold';
    case 'silver':
      return 'Silver';
    case 'branded':
      if (depthTier === 'gold') {
        return 'Gold';
      }
      if (depthTier === 'silver') {
        return 'Silver';
      }
      return 'Branded';
    case 'basic':
      return 'Basic';
    default:
      return undefined;
  }
};

export default getDepthTierLabel;
